const ANGULAR_MIGRATION_RELOAD_KEY = 'kjvreader.angular-sw-migrated';

export async function reconcileServiceWorkers(): Promise<void> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  const registrations = await navigator.serviceWorker.getRegistrations();
  const angularRegistrations = registrations.filter((registration) =>
    [
      registration.active?.scriptURL,
      registration.waiting?.scriptURL,
      registration.installing?.scriptURL,
    ].some((scriptUrl) => scriptUrl?.includes('/ngsw-worker.js')),
  );

  if (angularRegistrations.length > 0) {
    await Promise.all(angularRegistrations.map((registration) => registration.unregister()));
    await deleteAngularServiceWorkerCaches();

    if (
      navigator.serviceWorker.controller?.scriptURL.includes('/ngsw-worker.js') &&
      sessionStorage.getItem(ANGULAR_MIGRATION_RELOAD_KEY) !== 'true'
    ) {
      sessionStorage.setItem(ANGULAR_MIGRATION_RELOAD_KEY, 'true');
      location.reload();
      return;
    }
  }

  if (import.meta.env.PROD) {
    await navigator.serviceWorker.register('/service-worker.js');
  }
}

async function deleteAngularServiceWorkerCaches(): Promise<void> {
  if (typeof caches === 'undefined') {
    return;
  }

  const keys = await caches.keys();
  await Promise.all(
    keys.filter((key) => key.startsWith('ngsw:')).map((key) => caches.delete(key)),
  );
}
